<div class="container">
  <div class="footer">


    <div class="footer-distributed">
      <h2 class="branding"><app-brand-mark [size]="40"></app-brand-mark>Promo<span>Deep</span>
      </h2>
      <p class="footer-company-name">{{ 'footer.commission' | t }}</p>
      <mat-divider></mat-divider>
      <br>
      <div class="footer-left">




        <p style="font-weight: bold;">{{ 'footer.company' | t }}</p>
        <div>
          <a class="a-padding" routerLink="contact">{{ 'footer.contact' | t }}</a>
        </div>
        <div>
          <a class="a-padding" routerLink="about">{{ 'footer.about' | t }}</a>
        </div>



      </div>

      <div class="footer-center">


        <p style="font-weight: bold;">{{ 'footer.legal' | t }}</p>
        <div>
          <a class="a-padding" routerLink="legalNotice">{{ 'footer.legalNotice' | t }}</a>
        </div>
        <div>
          <a class="a-padding" routerLink="privacyPolicy">{{ 'footer.privacyPolicy' | t }}</a>
        </div>
        <div>
          <a class="a-padding" routerLink="cookies">{{ 'footer.cookiesPolicy' | t }}</a>
        </div>
        <div>
          <a class="a-padding" href="javascript:void(0)" (click)="showCookieDialog()">{{ 'cookies.manage' | t }}</a>
        </div>
        <div>
          <a class="a-padding" routerLink="generalPolicy">{{ 'footer.terms' | t }}</a>
        </div>
      </div>
        <div class="footer-right">

          <p class="footer-company-about">
            <span>{{ 'footer.joinUs' | t }}</span>
          </p>

          <div class="footer-icons">

            <!-- Pages renseignées dans le back office (Administration → Social networks) -->
            @for (link of socialLinks$ | async; track link.network) {
              <ng-template #logo>
                @if (link.svgPath) {
                  <svg class="social-icon" viewBox="0 0 24 24" aria-hidden="true"><path [attr.d]="link.svgPath"></path></svg>
                } @else {
                  <i [class]="link.iconClass" aria-hidden="true"></i>
                }
              </ng-template>
              @if (link.url) {
                <a [href]="link.url" [attr.target]="link.network === 'email' ? null : '_blank'" rel="noopener noreferrer"
                  [attr.aria-label]="link.label || ('footer.socialEmail' | t)" [title]="link.label || ('footer.socialEmail' | t)">
                  <ng-container [ngTemplateOutlet]="logo"></ng-container>
                </a>
              } @else {
                <!-- Adresse pas encore renseignée dans le back office -->
                <span class="social-link" [title]="link.label || ('footer.socialEmail' | t)">
                  <ng-container [ngTemplateOutlet]="logo"></ng-container>
                </span>
              }
            }
          </div>
          <br>
          <p class="footer-company-about">
            <span>{{ 'footer.findApps' | t }}</span>
          </p>

          <div class="footer-icons">

            <a href="https://apps.apple.com/app/promodeep/id6448401465" target="_blank" rel="noopener noreferrer" aria-label="IOS">
              <p class="pi pi-apple"></p>
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.promodeep.twa" target="_blank" rel="noopener noreferrer" aria-label="android">
              <p class="pi pi-android"></p>
            </a>
          </div>

        </div>

      </div>
      <br>
      <div class="footer-distributed">
        <mat-divider></mat-divider>

        <p class="footer-company-name"> <a href="https://www.technodeep.tech/" target="_blank" rel="noopener noreferrer" aria-label="technodeep">
          TechnoDeep
        </a> &copy; <span class="year">{{year}}</span> - <b>PromoDeep</b>, {{ 'footer.rights' | t }}</p>
      </div>
      <br>
      <br>
      <br>
    </div>

  </div>
